import { Injectable } from "@angular/core";
import { RestClientService } from "src/app/core/services/rest/rest-client.service";
import { Notification } from "../../models/Notification";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(private _restClientService: RestClientService) {}

  loadUnreadNotifications(recipient: string) {
    return this._restClientService.load<Notification[]>(
      `websocket/notifications/unread/${recipient}`
    );
  }
  
  loadreadNotifications(recipient: string) {
    return this._restClientService.load<Notification[]>(
      `websocket/notifications/read/${recipient}`
    );
  }

  loadAllNotifications(recipient: string) {
    return this._restClientService.load<Notification[]>(
      `websocket/notifications/all/${recipient}`
    );
  }


  markAllAsRead(recipient: string) {
    return this._restClientService.put<Notification>(
      `websocket/notifications/mark-all-read/${recipient}`, {}
    );
  }

  markAsRead(notificationId: number, recipient: string) {
    return this._restClientService.put<Notification>(
      `websocket/notifications/mark-read/${notificationId}/${recipient}`, {}
    );
  }

  delete(notificationId: number) {
    return this._restClientService.delete<Notification>(
      `websocket/notifications/delete/${notificationId}`
    );
  }




}
